__webpack_require__.p = "/NamasteNews/";